import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import Button from '../../Button';
import TextInput from '../../TextInput';
import Tooltip from '../Tooltip';
import Icon from '../../Icon';
import RenderTemporary from '../../RenderTemporary';

import { COLORS } from '../../../constants/styles';

import styles from './index.styl';

const CopyToClipboard = ({ title, link, buttonText, copySuccessText }) => {
  const textareaRef = useRef();

  const [copySuccess, setCopySuccess] = useState(false);

  const copyToClipboard = () => {
    textareaRef.current.select();
    document.execCommand('copy');
    setCopySuccess(true);
  };

  const tooltipContent = () => {
    return (
      <div className="flex items-start">
        <Icon name="success" size={12} style={{ fill: COLORS.greenLime }} />
        <div className="ml2">
          <p className="f-14">{copySuccessText}</p>
          <p className="f-12">{link}</p>
        </div>
      </div>
    );
  };

  return (
    <div styleName="root">
      <span>{title}</span>
      <div styleName="content">
        <div styleName="input">
          <TextInput
            name="text"
            rounded
            type="text"
            value={link}
            readOnly
            setRef={textareaRef}
            className="flex-grow-1"
          />
        </div>
        <Button color="primary" raised type="button" onClick={copyToClipboard}>
          {buttonText}
        </Button>
        <RenderTemporary rendered={copySuccess} timeout={2000}>
          <Tooltip
            content={tooltipContent()}
            top={15}
            left={0}
            width={250}
            open
          />
        </RenderTemporary>
      </div>
    </div>
  );
};

CopyToClipboard.propTypes = {
  title: PropTypes.string,
  link: PropTypes.string,
  buttonText: PropTypes.string,
  copySuccessText: PropTypes.string,
};

CopyToClipboard.defaultProps = {
  title: null,
  link: null,
  buttonText: null,
  copySuccessText: null,
};

export default CSSModules(CopyToClipboard, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/CopyToClipboard/index.jsx